import { memo, PropsWithChildren } from 'react';
import { BaseImageProps } from './Image.types';

export const BackgroundImage = memo(({ src, className, description, textOnImage, children }: PropsWithChildren<BaseImageProps>) => {
	return (
		<div
			className={className}
			style={{ backgroundImage: `url(${src})` }}
			role="img"
			aria-label={`${description} ${textOnImage}`}
			title={textOnImage}
		>
			{children}
		</div>
	);
});
